import { render } from "./RegisterOnline.vue?vue&type=template&id=3008dcd6"
import script from "./RegisterOnline.vue?vue&type=script&lang=js"
export * from "./RegisterOnline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__